module.exports = {
  siteTitle: 'ペンギン日記', // <title>
  manifestName: 'iPhoneアプリ ペンギン日記',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#0F6C96',
  manifestThemeColor: '#0F6C96',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-newage/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  socialLinks: [
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/masao-saeki-8b71a671/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/penguindiaryapp',
    },
  ],
};
